export default "__VITE_ASSET__CEK8Grhm__"